/**
 * Admin inventory catalogue browse/search — ops-volume SKUs for quote matching.
 */

import api from "@/shared/api";

const BASE = "/pricing/inventory-catalogue";

/**
 * @returns {Promise<object>}
 */
export async function fetchInventoryCatalogueMeta() {
  const response = await api.get(`${BASE}/meta`);
  return response?.data ?? response;
}

/**
 * @returns {Promise<object>}
 */
export async function fetchInventoryCatalogueGroups() {
  const response = await api.get(`${BASE}/groups`);
  return response?.data ?? response;
}

/**
 * @param {{ section?: string, q?: string, limit?: number }} [query]
 * @returns {Promise<object>}
 */
export async function listInventoryCatalogueItems(query = {}) {
  const params = new URLSearchParams();
  if (query.section) params.set("section", query.section);
  if (query.q) params.set("q", query.q);
  if (query.limit != null) params.set("limit", String(query.limit));
  const qs = params.toString();
  const response = await api.get(`${BASE}${qs ? `?${qs}` : ""}`);
  return response?.data ?? response;
}

/**
 * @param {{ description: string, section?: string, sizeVariant?: string, pwaRoom?: string }} query
 * @returns {Promise<object>}
 */
export async function resolveInventoryCatalogueItem(query) {
  const response = await api.post(`${BASE}/resolve`, query);
  return response?.data ?? response;
}
